/* ShimmerText.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40keyframes%20k1cqqt0g%7B0%25%7Bbackground-position%3A200%25%200%7Dto%7Bbackground-position%3A-200%25%200%7D%7D%0A._2uo31fSyNX%7Bbackground%3Alinear-gradient(90deg%2Cvar(--ds-text-subtlest%2C%236b6e76)%200%2Cvar(--ds-text-subtlest%2C%236b6e76)%2020%25%2C%23c7cddc%2040%25%2Cvar(--ds-text-subtlest%2C%236b6e76)%2060%25%2Cvar(--ds-text-subtlest%2C%236b6e76)%2080%25%2C%23c7cddc%2090%25%2Cvar(--ds-text-subtlest%2C%236b6e76)%20100%25)%7D%0A._2fBhteSSZw%7Banimation%3Ak1cqqt0g%204s%20linear%20infinite%7D%0A._3OqcjTzGaF%7Bbackground-size%3A200%25%20100%25%7D%0A._02U3A5JxkL%7B-webkit-background-clip%3Atext%7D%0A._1CY1NjjOvk%7B-webkit-text-fill-color%3Atransparent%7D%0A._07XDTDJxkL%7B-webkit-background-clip%3Atext%3Bbackground-clip%3Atext%7D%0A._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._39HuIbz8Lp%7Btext-overflow%3Aellipsis%7D%0A._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D%0A._4ouGXIdnbC%7Bmin-width%3A0%7D%0A._39xV02N91d%7Bwidth%3A100%25%7D%0A._1EqgXlN91d%7Bmax-width%3A100%25%7D");













import { Text } from '@atlaskit/primitives/compiled/text';
const shimmerAnimation = null;
const shimmerGradient = null;

/** Single-line ellipsis + flex/grid-safe width. */
const truncateSingleLine = null;
type ShimmerTextProps = {
  as?: 'div' | 'span';
  children: React.ReactNode;
  size?: 'small' | 'medium' | 'large';
  weight?: 'regular' | 'medium' | 'semibold';
  /**
   * Truncation is applied on this wrapper (not `Text maxLines`) so the
   * gradient and ellipsis share one box and `white-space` does not break clamping.
   * @default false
   */
  truncate?: boolean;
};
export const ShimmerText = ({
  as = 'div',
  children,
  size = 'medium',
  weight = 'regular',
  truncate = false
}: ShimmerTextProps): JSX.Element => {
  const content = <Text size={size} weight={weight} color="color.text.subtlest">
			{children}
		</Text>;
  if (as === 'span') {
    return <span className={ax(["_2uo31fSyNX _2fBhteSSZw _3OqcjTzGaF _02U3A5JxkL _1CY1NjjOvk _07XDTDJxkL", truncate && "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC _39xV02N91d _1EqgXlN91d"])}>{content}</span>;
  }
  return <div className={ax(["_2uo31fSyNX _2fBhteSSZw _3OqcjTzGaF _02U3A5JxkL _1CY1NjjOvk _07XDTDJxkL", truncate && "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC _39xV02N91d _1EqgXlN91d"])}>{content}</div>;
};